import React, { forwardRef } from "react";
import moment from "moment";
import "moment-duration-format";
import { usePaceTimerDownload } from "../../../components/shared/PaceTimer/usePaceTimerDownload";
import PaceTimerButtons from "../../../components/shared/PaceTimer/PaceTimerButtons";

import station_icon from "../../../assets/images/station-icon.png";
import station_icon_noselect from "../../../assets/images/station-icon-noSeleted.png";

import wristband_img2 from "../../../assets/images/wristband_img2.png";
import wristband_sticky from "../../../assets/images/wristband_sticky.jpg";


function FullTimer(props) {
    const {
        handleHydrationStationsChange,
        results,
        formatTime,
        formatMMSS,
        raceTime,
        handleShowMap,
        showYoutubeVideo,
        chrckInput,
    } = props;

    // 使用共用的下載 hook
    const { printableRef, handleDownloadImage } = usePaceTimerDownload({
        checkInput: chrckInput,
        filename: "喵喵問個痛台北馬配速手環_全馬_4x6.jpg",
        shareTrackingEvent: "2025台北馬拉松-分享配速手環-全馬",
        downloadTrackingEvent: "2025台北馬拉松-下載配速手環-全馬",
    });

    const calculateIntervalDistance = (index) => (index + 1) * 2.5;
    const calculateDisplayDistance = (index, isLastInterval) =>
        isLastInterval ? "終點" : calculateIntervalDistance(index);

    //上半馬計算
    const halfCumulativeTimes = moment.duration(results.formattedCumulativeTimes[7]).asSeconds(); // 離站時間
    const halfZonetime = moment.duration(`00:${results.formattedZoneTimes[8]}`).asSeconds(); // 配速
    const upperHalfMarathonCumulativeTimes = halfCumulativeTimes + halfZonetime * 1.1;
    const formattedUpperHalfMarathonCumulativeTimes = formatTime(upperHalfMarathonCumulativeTimes);
    const upperHalfMarathonZonetims = upperHalfMarathonCumulativeTimes / 21.1;
    const formatedUpperHalfMarathonZonetims = formatMMSS(upperHalfMarathonZonetims);
    //  下半馬計算
    const fullCumulativeTimes = moment.duration(results.formattedCumulativeTimes[16]).asSeconds();
    const lowerMarathonCumulativeTimes = fullCumulativeTimes - upperHalfMarathonCumulativeTimes;
    const formattedLower = formatTime(lowerMarathonCumulativeTimes);
    const lowerZonetime = lowerMarathonCumulativeTimes / 21.1;
    const formattedLowerZonetime = formatMMSS(lowerZonetime);

    return (
        <div className="timer-result-wrap">
            <FullTimerPrintable
                ref={printableRef}
                results={results}
                formatTime={formatTime}
                formatMMSS={formatMMSS}
                raceTime={raceTime}
                handleHydrationStationsChange={handleHydrationStationsChange}
                calculateDisplayDistance={calculateDisplayDistance}
                upperHalfMarathonZonetims={upperHalfMarathonZonetims}
                formatedUpperHalfMarathonZonetims={formatedUpperHalfMarathonZonetims}
                formattedUpperHalfMarathonCumulativeTimes={
                    formattedUpperHalfMarathonCumulativeTimes
                }
                formattedLower={formattedLower}
                formattedLowerZonetime={formattedLowerZonetime}
            />
            <div className="pace-result">
                <table className="pace-table">
                    <thead>
                        <tr>
                            <th scope="col">距離</th>
                            <th scope="col">停秒</th>
                            <th scope="col">離站時間</th>
                            <th scope="col">配速</th>
                            <th scope="col">注意事項</th>
                        </tr>
                    </thead>
                    <tbody>
                        {results.note.map((time, index) => {
                            const isLastInterval = index === results.note.length - 1;
                            const colSpanValue = isLastInterval ? 2 : 1;
                            return (
                                <tr key={index}>
                                    <td colSpan={colSpanValue}>
                                        {calculateDisplayDistance(index, isLastInterval)}
                                    </td>
                                    {!isLastInterval && (
                                        <td>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "4px",
                                                    flexWrap: "nowrap",
                                                }}
                                            >
                                                <img
                                                    className="stationWater-icon"
                                                    src={
                                                        results.hydrationStations[index]
                                                            ? station_icon
                                                            : station_icon_noselect
                                                    }
                                                    alt={
                                                        results.hydrationStations[index]
                                                            ? "Checked"
                                                            : "Unchecked"
                                                    }
                                                    onClick={(e) =>
                                                        handleHydrationStationsChange(e, index)
                                                    }
                                                />
                                                <span>
                                                    {results.hydrationStations[index]
                                                        ? raceTime.hydrationTime
                                                        : ""}
                                                </span>
                                            </div>
                                        </td>
                                    )}
                                    <td>{results.formattedCumulativeTimes[index]}</td>
                                    <td>{results.formattedZoneTimes[index]}</td>
                                    <td>{results.note[index]}</td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td colSpan={2}>上半馬</td>
                            <td>
                                {formattedUpperHalfMarathonCumulativeTimes
                                    ? formattedUpperHalfMarathonCumulativeTimes
                                    : ""}
                            </td>
                            <td>
                                {formatedUpperHalfMarathonZonetims
                                    ? formatedUpperHalfMarathonZonetims
                                    : ""}
                            </td>
                            <td>{""}</td>
                        </tr>
                        <tr>
                            <td colSpan={2}>下半馬</td>
                            <td>{formattedLower ? formattedLower : ""}</td>
                            <td>{formattedLowerZonetime ? formattedLowerZonetime : ""}</td>
                            <td>{""}</td>
                        </tr>
                    </tbody>
                </table>
                <PaceTimerButtons
                    onDownload={handleDownloadImage}
                    onShowMap={handleShowMap}
                    onShowVideo={showYoutubeVideo}
                    mapTrackingEvent="2025台北馬拉松-賽道地圖"
                    videoTrackingEvent="2025台北馬拉松-賽道影片"
                />
            </div>
        </div>
    );
}

const FullTimerPrintable = forwardRef((props, ref) => {
    const {
        results,
        raceTime,
        handleHydrationStationsChange,
        calculateDisplayDistance,
        formatedUpperHalfMarathonZonetims,
        formattedLowerZonetime,
        formattedUpperHalfMarathonCumulativeTimes,
        formattedLower,
    } = props;

    return (
        <div className="printable full-timer" ref={ref}>
            <div className="print-container">
                <div className="print-ring">
                    <p className="ring-title">2025台北馬拉松配速</p>
                    <table className="pace-table-input">
                        <thead>
                            <tr>
                                <th scope="col">距離</th>
                                <th scope="col">停秒</th>
                                <th scope="col">離站時間</th>
                                <th scope="col">配速</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.note.map((time, index) => {
                                const isLastInterval = index === results.note.length - 1;
                                const colSpanValue = isLastInterval ? 2 : 1;
                                return (
                                    <tr
                                        key={index}
                                        className={isLastInterval ? "finishi-count" : ""}
                                    >
                                        <td colSpan={colSpanValue}>
                                            {calculateDisplayDistance(index, isLastInterval)}
                                        </td>
                                        {!isLastInterval && (
                                            <td>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        marginLeft: "15px",
                                                        gap: "4px",
                                                        flexWrap: "nowrap",
                                                    }}
                                                >
                                                    <img
                                                        className="stationWater-icon"
                                                        src={
                                                            results.hydrationStations[index]
                                                                ? station_icon
                                                                : station_icon_noselect
                                                        }
                                                        alt={
                                                            results.hydrationStations[index]
                                                                ? "Checked"
                                                                : "Unchecked"
                                                        }
                                                        onClick={(e) =>
                                                            handleHydrationStationsChange(e, index)
                                                        }
                                                    />
                                                    <span>
                                                        {results.hydrationStations[index]
                                                            ? raceTime.hydrationTime
                                                            : ""}
                                                    </span>
                                                </div>
                                            </td>
                                        )}
                                        <td>
                                            {moment(
                                                results.formattedCumulativeTimes[index],
                                                "HH:mm:ss"
                                            ).format("H:mm:ss")}
                                        </td>
                                        <td>{results.formattedZoneTimes[index]}</td>
                                    </tr>
                                );
                            })}
                            <tr className="finishi-count">
                                <td colSpan={2}>上半馬</td>
                                <td>
                                    {moment(
                                        formattedUpperHalfMarathonCumulativeTimes,
                                        "HH:mm:ss"
                                    ).format("H:mm:ss")}
                                </td>
                                <td>{formatedUpperHalfMarathonZonetims}</td>
                            </tr>
                            <tr className="finishi-count">
                                <td colSpan={2}>下半馬</td>
                                <td>{moment(formattedLower, "HH:mm:ss").format("H:mm:ss")}</td>
                                <td>{formattedLowerZonetime}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="diy-sub-card-wrap">
                    <img
                        className="diy-sub-card"
                        src={wristband_img2}
                        alt="DIY娘娘玉手示意圖-正面"
                    />
                    <p>⬆️ 完賽祝福御守 </p>
                    <p>延長配速手環用 ⬇️</p>
                    <img src={wristband_sticky} alt="DIY娘娘玉手示意圖-黏貼區" />
                </div>
            </div>
        </div>
    );
});

export default FullTimer;
